import Terraviaf1 from '../../../Media/Fasilitas BSD/Terravia/Terravia (1).webp'
import Terraviaf2 from '../../../Media/Fasilitas BSD/Terravia/Terravia (2).webp'
import Terraviaf3 from '../../../Media/Fasilitas BSD/Terravia/Terravia (3).webp'
import Terraviaf4 from '../../../Media/Fasilitas BSD/Terravia/Terravia (4).webp'




const Terraviafimages =[
Terraviaf1,Terraviaf2,Terraviaf3,Terraviaf4
]

export default Terraviafimages;